import { type FC } from "react";
import NavbarSidebarLayout from "../layouts/navbar-sidebar";
import { CampaignListNew } from "../components/campaigns/CampaignListNew";

const CampaignsPage: FC = function () {
  return (
    <NavbarSidebarLayout>
      <CampaignListNew />
    </NavbarSidebarLayout>
  );
};

export default CampaignsPage;
